import { useRecoilState } from 'recoil';
import { btnColor } from '../../GlobalState';
import { parsePrice } from '../../utils';
import { Button, TableRow } from '@material-ui/core';
import NumberInput from '../NumberInput';
import { StyledTableCell } from './Style';
import { useStyles } from './Style';

import {
  handleTextValidation,
  validateTextareaInput
} from '../../../src/utils/estimate';

type Tprops = {
  mUnitsData: any;
  layer: number;
  item: any;
  updateSecondItemList: any;
  index: number;
  thirdIndex?: number;
  fourthIndex?: number;
  fifthIndex?: number;
};

export const ItemList: React.FC<Tprops> = (props: Tprops) => {
  const {
    mUnitsData,
    layer,
    item,
    updateSecondItemList,
    index,
    thirdIndex,
    fourthIndex,
    fifthIndex
  } = props;

  const classes = useStyles();
  const [buttonColor] = useRecoilState(btnColor);

  return (
    <>
      <TableRow>
        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 130 }}
        >
          {layer !== 5 &&
            item.sellingUnitPrice == 0 &&
            item.costUnitPrice == 0 && (
              <select
                value={item.hasUnderLayerFlg}
                disabled={
                  item.hasUnderLayerFlg == true && item.childItems.length > 0
                }
                onChange={text => {
                  updateSecondItemList(
                    true,
                    layer,
                    'hasUnderLayerFlg',
                    text.target.value,
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
                className={classes.selectLayerType}
                name='cars'
                form='carform'
              >
                <option value='true'>明細あり</option>
                <option value='false'>明細なし</option>
              </select>
            )}
        </StyledTableCell>
        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 70 }}
        >
          {item.layer ? item.layer : 2}
        </StyledTableCell>
        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 300 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              <input
                value={item.name}
                autoFocus={
                  item.name === '' && typeof item.id === 'string' ? true : false
                }
                maxLength={20}
                placeholder={'20文字以内で入力'}
                onChange={text => {
                  updateSecondItemList(
                    true,
                    layer,
                    'name',
                    text.target.value,
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
                className={`${classes.input2}`}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 300 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              <textarea
                value={item.spec}
                maxLength={42}
                style={{
                  height: 50,
                  maxHeight: 60,
                  fontSize: 15.5,
                  width: '36ch'
                }}
                placeholder={'40文字以内、2行以内'}
                onChange={text => {
                  handleTextValidation(
                    text.target.value,
                    40,
                    2,
                    null,
                    (cleanText: string) => {
                      validateTextareaInput(
                        'spec',
                        cleanText,
                        (cleanText: string) => {
                          updateSecondItemList(
                            true,
                            layer,
                            'spec',
                            cleanText,
                            index,
                            thirdIndex,
                            fourthIndex,
                            fifthIndex
                          );
                        }
                      );
                    }
                  );
                }}
                className={`${classes.input2}`}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 120 }}
        >
          <div className={`${classes.inputMainContainer} ${classes.subCell}`}>
            <div className={classes.inputDetailContainer}>
              <input
                value={item.quantity}
                type='number'
                min='0'
                onChange={text => {
                  updateSecondItemList(
                    true,
                    layer,
                    'quantity',
                    parseFloat(text.target.value),
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
                className={classes.smallQuantityInput}
                onWheel={(e: any) => e.target.blur()}
              />
            </div>
          </div>
          <div
            className={`${classes.inputMainContainer} ${classes.subCostCell}`}
          >
            <div className={classes.inputDetailContainer}>
              （
              <input
                value={item.costQuantity}
                type='number'
                min='0'
                onChange={text => {
                  updateSecondItemList(
                    true,
                    layer,
                    'costQuantity',
                    parseFloat(text.target.value),
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
                className={classes.smallCostQuantityInput}
                onWheel={(e: any) => e.target.blur()}
              />
              ）
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 120 }}
        >
          <div className={`${classes.inputMainContainer} ${classes.subCell}`}>
            <div className={classes.inputDetailContainer}>
              <select
                value={item.unitId}
                onChange={text => {
                  updateSecondItemList(
                    true,
                    layer,
                    'unitId',
                    text.target.value,
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
                className={classes.selectBoxStyle}
                name='cars'
                form='carform'
              >
                <option value='0'>---</option>
                {mUnitsData.map((i: any) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>
            </div>
          </div>
          <div
            className={`${classes.inputMainContainer} ${classes.subCostCell}`}
          >
            <div className={classes.inputDetailContainer}>
              （
              <select
                value={item.costUnitId}
                onChange={text => {
                  updateSecondItemList(
                    true,
                    layer,
                    'costUnitId',
                    text.target.value,
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
                className={classes.selectBoxCost}
                name='cars'
                form='carform'
              >
                <option disabled selected value='0'>
                  ---
                </option>
                {mUnitsData.map((i: any) => (
                  <option value={i.id}>{i.name}</option>
                ))}
              </select>
              ）
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 120 }}
        >
          <div className={`${classes.inputMainContainer} ${classes.subCell}`}>
            <div className={classes.inputDetailContainer}>
              <NumberInput
                symbol=''
                value={
                  item.sellingUnitPrice === 0 ? '0' : item.sellingUnitPrice
                }
                disabled={item.hasUnderLayerFlg == true}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateSecondItemList(
                    true,
                    layer,
                    'sellingUnitPrice',
                    e.target.value ? Number(e.target.value) : 0,
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
                className={classes.smallInput}
                dynamicCalculation={true}
              />
            </div>
          </div>
          <div
            className={`${classes.inputMainContainer} ${classes.subCostCell}`}
          >
            <div className={classes.inputDetailContainer}>
              （
              <NumberInput
                symbol=''
                value={item.costUnitPrice === 0 ? '0' : item.costUnitPrice}
                disabled={item.hasUnderLayerFlg == true}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  updateSecondItemList(
                    true,
                    layer,
                    'costUnitPrice',
                    e.target.value ? Number(e.target.value) : 0,
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
                className={classes.smallCostInput}
                dynamicCalculation={true}
              />
              ）
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='right'
          style={{ width: 120 }}
        >
          <div className={`${classes.inputMainContainer} ${classes.subCell}`}>
            <div className={classes.inputContainer}>
              {parsePrice(item.allSellingPrice, '')}
            </div>
          </div>
          <div
            className={`${classes.inputMainContainer} ${classes.subCostCell}`}
          >
            {item.allCostPrice !== '' && (
              <div className={classes.inputAllCostPriceContainer}>
                （
                <span style={{ color: 'blue' }}>
                  {parsePrice(item.allCostPrice, '')}
                </span>
                ）
              </div>
            )}
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='right'
          style={{ width: 80 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              {parsePrice(item.grossProfit, '')}
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 80 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              {item.grossProfitMargin} %
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 300 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              <textarea
                value={item.remarks}
                maxLength={42}
                style={{
                  height: 47,
                  maxHeight: 60,
                  fontSize: 15.5,
                  width: '36ch'
                }}
                placeholder={'【備考】40文字以内、2行以内'}
                onChange={text => {
                  handleTextValidation(
                    text.target.value,
                    40,
                    2,
                    null,
                    (cleanText: string) => {
                      validateTextareaInput(
                        'remarks',
                        cleanText,
                        (cleanText: string) => {
                          updateSecondItemList(
                            true,
                            layer,
                            'remarks',
                            cleanText,
                            index,
                            thirdIndex,
                            fourthIndex,
                            fifthIndex
                          );
                        }
                      );
                    }
                  );
                }}
                className={`${classes.input2}`}
              />
              <textarea
                value={item.author_memo}
                maxLength={42}
                style={{
                  height: 47,
                  maxHeight: 60,
                  fontSize: 15.5,
                  width: '36ch'
                }}
                placeholder={'【社内用メモ】40文字以内、2行以内'}
                onChange={text => {
                  handleTextValidation(
                    text.target.value,
                    40,
                    2,
                    null,
                    (cleanText: string) => {
                      validateTextareaInput(
                        'author_memo',
                        cleanText,
                        (cleanText: string) => {
                          updateSecondItemList(
                            true,
                            layer,
                            'author_memo',
                            cleanText,
                            index,
                            thirdIndex,
                            fourthIndex,
                            fifthIndex
                          );
                        }
                      );
                    }
                  );
                }}
                className={`${classes.smallMemoInput}`}
              />
            </div>
          </div>
        </StyledTableCell>

        <StyledTableCell
          className={classes.tableBody}
          align='center'
          style={{ width: 100 }}
        >
          <div className={classes.inputMainContainer}>
            <div className={classes.inputContainer}>
              <Button
                style={{ backgroundColor: buttonColor }}
                variant='contained'
                color='primary'
                onClick={() => {
                  updateSecondItemList(
                    false,
                    layer,
                    '',
                    '',
                    index,
                    thirdIndex,
                    fourthIndex,
                    fifthIndex
                  );
                }}
              >
                削除
              </Button>
            </div>
          </div>
        </StyledTableCell>
      </TableRow>
    </>
  );
};
